<template>
    <div>
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'UserGuestComponent'
}
</script>

<style scoped>

</style>